export const queryParams = {
	fields: ['id'],
	populate: {
		header: {
			populate: {
				logo: {
					populate: {
						fields: ['url', 'alt'],
						image: {
							fields: ['url'],
						},
					},
				},
				rightImage: {
					fields: ['url'],
				},
			},
		},
		body: {
			populate: {
				bgImage: {
					fields: ['url'],
				},
				banner: {
					populate: {
						image: {
							fields: ['url'],
						},
					},
				},
			},
		},
		footer: {
			populate: {
				footerTop: {
					populate: {
						quickAccess: {
							populate: {
								icon: {
									populate: true,
								},
							},
						},
						address: {
							populate: {
								addressItem: {
									populate: true,
								},
							},
						},
					},
				},
				footerBottom: {
					populate: {
						legalList: {
							populate: true,
						},
						ctLogo: {
							populate: true,
						},
					},
				},
			},
		},
		socialMedia: {
			populate: {
				icon: {
					populate: true,
				},
			},
		},
	},
};
